(function () {
  const Core = window.RB.Core;

  const Flow = {
    advance(state) {
      let guard = 0;
      while (!state.pending && !state.over) {
        if (++guard > 5000) throw new Error("advance loop stuck");
        if (!Flow.schedule(state)) break;
      }
    },

    schedule(state) {
      if (state.over) return false;

      if (state.tasks.length) {
        const frame = state.tasks[state.tasks.length - 1];
        const res = Flow.stepFrame(state, frame);
        if (res === "done") {
          const i = state.tasks.indexOf(frame);
          if (i >= 0) state.tasks.splice(i, 1);
        }
        return true;
      }

      if (state.needCleanup) {
        Flow.cleanupPass(state);
        return true;
      }

      if (state.triggerQueue.length) {
        Flow.drainTriggers(state);
        return true;
      }

      const pendingItems = state.chain.filter(function (it) { return it.status === "pending"; });
      if (pendingItems.length) {
        const oldest = pendingItems[0];
        state.tasks.push({ k: "finalize", chainId: oldest.id, step: 0, answers: {} });
        return true;
      }

      if (state.chain.length) {
        if (state.passCount >= 2) {
          const newest = state.chain[state.chain.length - 1];
          RB.FX.emit(state, RB.FX.chainEvent("resolving", newest, { left: state.chain.length }));
          if (newest.logMark !== state.gameLog.length) {
            Core.log(state, newest.label + " resolves.", {
              k: "resolve", p: newest.controller,
              iids: [newest.iid || newest.source].filter(Boolean),
              tgt: Core.itemTargets(newest),
            });
          }
          state.tasks.push({ k: "resolve", chainId: newest.id });
          state.passCount = 0;
          return true;
        }
        const respondTo = state.priority === null || state.priority === undefined
          ? state.chain[state.chain.length - 1].controller
          : state.priority;
        state.pending = {
          kind: "respond", player: respondTo,
          note: "Chain: " + state.chain.map(function (i) { return i.label; }).join(" < "),
        };
        return true;
      }

      if (state.showdown) return Flow.stepShowdown(state);

      const staged = Flow.stagedBattlefields(state);
      if (staged.length && state.turn.phase !== "setup") {
        if (staged.length === 1) {
          Flow.initiateAt(state, staged[0]);
        } else {
          state.pending = {
            kind: "choose", player: state.turn.player, tag: "pickStaged",
            prompt: "Choose which battlefield opens first", cands: staged, min: 1, max: 1,
          };
        }
        return true;
      }

      return Flow.stepPhase(state);
    },

    stagedBattlefields(state) {
      return state.battlefields.filter(function (bfIid) {
        const bf = state.objs[bfIid];
        return bf.stagedShowdown || bf.stagedCombat;
      });
    },

    designate(state, iid, role, bfIid) {
      const o = state.objs[iid];
      o.designation = role;
      const flag = role === "attacker" ? "desigA" : "desigD";
      if (o.flags[flag]) return;
      o.flags[flag] = true;
      RB.FX.emit(state, { type: role === "attacker" ? "attack" : "defend", iid: iid, bf: bfIid });
    },

    initiateAt(state, bfIid) {
      const bf = state.objs[bfIid];
      const present = Core.playersUnitsAtBf(state, bfIid);
      const combat = bf.stagedCombat && present.length >= 2;
      bf.stagedShowdown = false;
      bf.stagedCombat = false;
      const contester = bf.contestedBy;
      state.showdown = {
        bf: bfIid,
        combat: combat,
        attacker: combat ? contester : null,
        defender: combat ? Core.otherPlayer(contester) : null,
        focus: contester,
        passes: 0,
        stage: "open",
        excess: {},
      };
      Core.log(state, (combat ? "Combat" : "Showdown") + " begins at " + Core.name(state, bfIid) + ".",
        { k: "combat", p: combat ? state.showdown.attacker : null, iids: [bfIid] });
      if (combat) {
        Flow.beginCombat(state, bfIid, state.showdown.attacker);
      } else {
        RB.FX.emit(state, { type: "showdownStart", bf: bfIid });
      }
      return true;
    },

    beginCombat(state, bfIid, attacker) {
      for (const iid of Core.unitsAt(state, { t: "bf", iid: bfIid })) {
        Flow.designate(state, iid, state.objs[iid].controller === attacker ? "attacker" : "defender", bfIid);
      }
      RB.FX.emit(state, { type: "combatStart", bf: bfIid });
    },

    declareWinner(state, p) {
      state.over = { winner: p };
      Core.log(state, state.players[p].name + " wins the game!", { k: "game", p: p });
    },

    stepShowdown(state) {
      const sd = state.showdown;
      if (sd.stage === "open") {
        if (sd.passes >= 2) {
          if (sd.combat) {
            sd.stage = "damageAtk";
            return true;
          }
          return Flow.closeNonCombatShowdown(state);
        }
        state.pending = {
          kind: "focus", player: sd.focus,
          note: (sd.combat ? "Combat showdown" : "Showdown") + " at " + Core.name(state, sd.bf),
        };
        return true;
      }

      if (sd.stage === "damageAtk" || sd.stage === "damageDef") {
        const atkSide = sd.stage === "damageAtk";
        const assigner = atkSide ? sd.attacker : sd.defender;
        const srcUnits = Core.unitsAt(state, { t: "bf", iid: sd.bf }, function (o) {
          return o.controller === assigner;
        });
        const tgtUnits = Core.unitsAt(state, { t: "bf", iid: sd.bf }, function (o) {
          return o.controller !== assigner;
        });
        if (!srcUnits.length || !tgtUnits.length) {
          if (atkSide) { sd.stage = "damageDef"; return true; }
          sd.stage = "dealDamage";
          return true;
        }
        const total = Core.combatTotal(state, sd.bf, assigner);
        if (total <= 0) {
          sd[atkSide ? "atkAssign" : "defAssign"] = {};
          sd.stage = atkSide ? "damageDef" : "dealDamage";
          return true;
        }
        state.pending = {
          kind: "assign", player: assigner, total: total, targets: tgtUnits,
          slot: atkSide ? "atkAssign" : "defAssign",
          note: "Assign " + total + " combat damage",
        };
        return true;
      }

      if (sd.stage === "dealDamage") {
        const deals = [];
        const collect = function (assign, byPlayer) {
          if (!assign) return;
          for (const iid in assign) {
            if (assign[iid] > 0) deals.push({ iid: iid, amt: assign[iid], by: byPlayer, src: "combat", bf: sd.bf });
          }
        };
        collect(sd.atkAssign, sd.attacker);
        collect(sd.defAssign, sd.defender);
        Flow.dealDamage(state, deals);
        Core.log(state, "Combat damage dealt at " + Core.name(state, sd.bf) + ".", { k: "combat", iids: [sd.bf] });
        sd.stage = "resolution";
        state.needCleanup = true;
        return true;
      }

      if (sd.stage === "resolution") {
        return Flow.combatResolution(state);
      }
      return false;
    },

    closeNonCombatShowdown(state) {
      const sd = state.showdown;
      const bfIid = sd.bf;
      const present = Core.playersUnitsAtBf(state, bfIid);
      state.showdown = null;
      const bf = state.objs[bfIid];
      if (present.length === 1) {
        const p = present[0];
        if (bf.controller !== p) Flow.establishControl(state, p, bfIid);
      }
      Core.log(state, "Showdown at " + Core.name(state, bfIid) + " ends.", { k: "combat", iids: [bfIid] });
      state.needCleanup = true;
      return true;
    },

    combatResolution(state) {
      const sd = state.showdown;
      const bfIid = sd.bf;
      for (const iid of Core.boardObjs(state)) {
        const o = state.objs[iid];
        if (o.damage.length && Core.isType(state, iid, "unit")) o.damage = [];
      }
      const defendersLeft = Core.unitsAt(state, { t: "bf", iid: bfIid }, function (o) {
        return o.controller === sd.defender;
      });
      const attackersHere = Core.unitsAt(state, { t: "bf", iid: bfIid }, function (o) {
        return o.controller === sd.attacker;
      });
      let recalled = false;
      if (defendersLeft.length && attackersHere.length) {
        const tieAll = RB.Scripts.anySource(state, "tieRecallAll", { controller: sd.attacker });
        const toRecall = tieAll ? attackersHere.concat(defendersLeft) : attackersHere;
        for (const iid of toRecall) Flow.recall(state, iid);
        recalled = true;
        Core.log(state, tieAll ? "All units recalled (tie)." : "Attackers recalled (defenders held).",
          { k: "combat", iids: toRecall });
      }
      const present = Core.playersUnitsAtBf(state, bfIid);
      const bf = state.objs[bfIid];
      if (present.length === 1) {
        const winner = present[0];
        if (!recalled) {
          Core.log(state, state.players[winner].name + " wins the combat at " + Core.name(state, bfIid) + ".",
            { k: "combat", p: winner, iids: [bfIid] });
        }
        if (bf.controller !== winner) Flow.establishControl(state, winner, bfIid);
        else bf.contestedBy = null;
      } else {
        bf.contestedBy = null;
        if (!present.length) bf.controller = null;
      }
      RB.FX.emit(state, { type: "combatEnd", bf: bfIid });
      for (const iid of Core.boardObjs(state)) {
        state.objs[iid].designation = null;
        state.objs[iid].flags.desigA = false;
        state.objs[iid].flags.desigD = false;
      }
      Flow.expireGrants(state, "combat");
      state.showdown = null;
      state.needCleanup = true;
      return true;
    },

    establishControl(state, p, bfIid) {
      const bf = state.objs[bfIid];
      bf.controller = p;
      bf.contestedBy = null;
      Core.log(state, state.players[p].name + " takes control of " + Core.name(state, bfIid) + ".",
        { k: "score", p: p, iids: [bfIid] });
      if (bf.scoredBy.indexOf(p) < 0) Flow.score(state, p, bfIid, "conquer");
    },

    score(state, p, bfIid, how) {
      const bf = state.objs[bfIid];
      bf.scoredBy.push(p);
      const player = state.players[p];
      let gained = false;
      const blocked = RB.Play.scoreBlocked(state, p, bfIid);
      if (blocked) {
        Core.log(state, state.players[p].name + " cannot score at " + Core.name(state, bfIid) + " (" + blocked + ").",
          { k: "score", p: p, iids: [bfIid] });
      } else if (how === "conquer" && player.points >= Core.victoryScore(state) - 1) {
        const scoredAll = state.battlefields.every(function (b) {
          return state.objs[b].scoredBy.indexOf(p) >= 0;
        });
        if (scoredAll) {
          player.points += 1;
          gained = true;
        } else {
          Core.log(state, state.players[p].name + " cannot take the final point (draws 1 instead).",
            { k: "score", p: p, iids: [bfIid] });
          Flow.draw(state, p, 1);
        }
      } else {
        player.points += 1;
        gained = true;
      }
      if (gained && how === "hold") state.turnFacts.players[p].heldPoints += 1;
      if (gained && how === "conquer") state.turnFacts.players[p].conqueredPoints += 1;
      if (gained) {
        Core.log(state, state.players[p].name + " scores (" + how + ") at " + Core.name(state, bfIid) + " → " + player.points + " pts.",
          { k: "score", p: p, iids: [bfIid] });
      }
      const stamps = state.turn[how === "conquer" ? "conqueredBfs" : "heldBfs"] || {};
      stamps[bfIid] = p;
      state.turn[how === "conquer" ? "conqueredBfs" : "heldBfs"] = stamps;
      RB.FX.emit(state, { type: how, bf: bfIid, player: p });
      for (const iid of Core.unitsAt(state, { t: "bf", iid: bfIid }, function (o) { return o.controller === p; })) {
        if (how === "conquer") state.objs[iid].flags.conqueredTurn = state.turn.num;
        const hunt = Core.kwVal(state, iid, "hunt");
        const huntTimes = 1 + RB.FX.extraScoreTriggers(state, "unit" + (how === "conquer" ? "Conquer" : "Hold"), bfIid, p);
        for (let rep = 0; hunt && rep < huntTimes; rep++) {
          state.triggerQueue.push({
            controller: p, source: iid,
            label: Core.name(state, iid) + ": Hunt " + hunt,
            program: [{ op: "xp", n: hunt }],
            targetSpecs: [],
            ctx: { bf: bfIid },
          });
        }
        RB.FX.emit(state, { type: "unit" + (how === "conquer" ? "Conquer" : "Hold"), iid: iid, bf: bfIid, player: p });
      }
      state.needCleanup = true;
    },

    cleanupPass(state) {
      state.needCleanup = false;

      for (let p = 0; p < 2; p++) {
        const pl = state.players[p];
        const opp = state.players[Core.otherPlayer(p)];
        if (pl.points >= Core.victoryScore(state) && pl.points > opp.points) {
          Flow.declareWinner(state, p);
          return;
        }
      }

      if (state.showdown && !state.showdown.combat && state.showdown.stage === "open") {
        const sd = state.showdown;
        const bf = state.objs[sd.bf];
        if (bf.contestedBy !== null) {
          const present = Core.playersUnitsAtBf(state, sd.bf);
          const contesterHere = Core.unitsAt(state, { t: "bf", iid: sd.bf }, function (o) {
            return o.controller === bf.contestedBy;
          }).length;
          if (present.length >= 2 && contesterHere) {
            sd.combat = true;
            sd.attacker = bf.contestedBy;
            sd.defender = Core.otherPlayer(bf.contestedBy);
            Core.log(state, "The showdown at " + Core.name(state, sd.bf) + " becomes a combat.",
              { k: "combat", p: sd.attacker, iids: [sd.bf] });
            Flow.beginCombat(state, sd.bf, sd.attacker);
          }
        }
      }

      if (state.showdown && state.showdown.combat) {
        const sd = state.showdown;
        for (const iid of Core.boardObjs(state)) {
          const o = state.objs[iid];
          if (!Core.isType(state, iid, "unit")) continue;
          const atBf = o.loc && o.loc.t === "bf" && o.loc.iid === sd.bf;
          if (atBf) {
            const want = o.controller === sd.attacker ? "attacker" : o.controller === sd.defender ? "defender" : null;
            if (want && o.designation !== want) Flow.designate(state, iid, want, sd.bf);
          } else if (o.designation) {
            o.designation = null;
          }
        }
      }

      const dead = [];
      for (const iid of Core.boardObjs(state)) {
        const o = state.objs[iid];
        if (Core.isType(state, iid, "unit") && !o.attachedTo && Core.lethal(state, iid)) dead.push(iid);
      }

      for (const iid of dead) {
        const dmg = state.objs[iid].damage;
        const last = dmg.length ? dmg[dmg.length - 1] : null;
        Flow.killObjs(state, [iid], {
          via: "cleanup",
          by: last ? last.by : undefined,
          bySpell: !!(last && last.bySpell),
        });
      }
      if (dead.length) state.needCleanup = true;

      const openState = state.chain.length === 0;
      for (const bfIid of state.battlefields) {
        const bf = state.objs[bfIid];
        const sdHere = state.showdown && state.showdown.bf === bfIid;
        if (bf.controller !== null && openState && !sdHere) {
          const mine = Core.unitsAt(state, { t: "bf", iid: bfIid }, function (o) {
            return o.controller === bf.controller;
          });
          if (!mine.length) {
            Core.log(state, state.players[bf.controller].name + " loses control of " + Core.name(state, bfIid) + ".",
              { k: "score", p: bf.controller, iids: [bfIid] });
            bf.controller = null;
            state.needCleanup = true;
          }
        }
      }

      for (const iid of Core.boardObjs(state)) {
        const o = state.objs[iid];
        if (o.attachedTo) continue;
        const isGear = Core.isType(state, iid, "gear") && !Core.isType(state, iid, "unit");
        const isRune = Core.isType(state, iid, "rune");
        if (isGear && o.loc && o.loc.t === "bf") {
          Flow.recall(state, iid);
          state.needCleanup = true;
        }
        if (o.loc && o.loc.t === "base" && o.loc.p !== o.controller) {
          Flow.recall(state, iid);
          state.needCleanup = true;
        }
      }

      for (const bfIid of state.battlefields) {
        const bf = state.objs[bfIid];
        for (const fd of Flow.hiddenAt(state, bfIid)) {
          if (bf.controller === state.objs[fd].controller) continue;
          Flow.clearHidden(state, bfIid, fd);
          Flow.toTrash(state, fd);
          Core.log(state, "Hidden card at " + Core.name(state, bfIid) + " is trashed.", { k: "zone", iids: [bfIid] });
          state.needCleanup = true;
        }
      }

      for (const bfIid of state.battlefields) {
        const bf = state.objs[bfIid];
        if (bf.contestedBy === null) {
          const sdHereNow = state.showdown && state.showdown.bf === bfIid;
          if (!sdHereNow) {
            Flow.contestByIntruder(state, bfIid);
          }
          if (bf.contestedBy === null) continue;
        }
        const sdHere = state.showdown && state.showdown.bf === bfIid;
        const contesterUnits = Core.unitsAt(state, { t: "bf", iid: bfIid }, function (o) {
          return o.controller === bf.contestedBy;
        });
        const present = Core.playersUnitsAtBf(state, bfIid);
        if (!sdHere) {
          if (contesterUnits.length) {
            bf.stagedShowdown = true;
            if (present.length >= 2) bf.stagedCombat = true;
            else bf.stagedCombat = false;
          } else {
            bf.contestedBy = null;
            bf.stagedShowdown = false;
            bf.stagedCombat = false;
            Flow.contestByIntruder(state, bfIid);
          }
        }
      }
      for (const bfIid of state.battlefields) {
        const bf = state.objs[bfIid];
        if (bf.contestedBy === null) { bf.stagedShowdown = false; bf.stagedCombat = false; }
      }

      Flow.controlLeasePass(state);
      Flow.mightyPass(state);
    },

    controlLeasePass(state) {
      for (const iid of Core.boardObjs(state)) {
        const o = state.objs[iid];
        if (!o.controlSrc) continue;
        const src = state.objs[o.controlSrc];
        if (src && src.zone === "board") continue;
        delete o.controlSrc;
        if (o.attachedTo) Flow.detach(state, iid);
        o.controller = o.owner;
        Flow.recall(state, iid);
        Core.log(state, Core.name(state, iid) + " returns to its owner's control.",
          { k: "state", p: o.owner, iids: [iid] });
        state.needCleanup = true;
      }
    },

    temporarySuppressed(state, iid) {
      const o = state.objs[iid];
      if (!o || !o.loc || o.loc.t !== "bf") return false;
      return RB.Scripts.anySource(state, "suppressTemporaryHere", { controller: o.controller, atBf: o.loc.iid });
    },

    mightyPass(state) {
      if (!RB.FX.anyListener(state, "becameMighty")) {
        if (state.mighty) delete state.mighty;
        return;
      }
      const prev = state.mighty || null;
      const next = {};
      const becoming = [];
      for (const iid of Core.boardObjs(state)) {
        const o = state.objs[iid];
        if (o.attachedTo || !Core.isType(state, iid, "unit")) continue;
        const m = Core.effMight(state, iid);
        if (m === null) continue;
        const now = m >= 5;
        next[iid] = now;
        if (now && prev && prev[iid] === false) becoming.push(iid);
      }
      state.mighty = next;
      for (const iid of becoming) {
        const o = state.objs[iid];
        if (!o || o.zone !== "board") continue;
        RB.FX.emit(state, { type: "becameMighty", iid: iid, player: o.controller });
      }
    },

    drainTriggers(state) {
      const q = state.triggerQueue;
      const order = [state.turn.player, Core.otherPlayer(state.turn.player)];
      for (const pl of order) {
        const mine = q.filter(function (t) { return t.controller === pl; });
        if (!mine.length) continue;
        const labels = {};
        for (const t of mine) labels[t.label] = 1;
        if (mine.length > 1 && Object.keys(labels).length > 1) {
          state.pending = {
            kind: "choose", player: pl, tag: "orderTriggers",
            prompt: "Order your simultaneous triggers — pick which goes on the chain next. " +
              "The chain resolves top-down, so the LAST one you place will resolve FIRST.",
            options: mine.map(function (t) { return t.label; }),

            srcCards: mine.map(function (t) {
              const so = t.source && state.objs[t.source];
              return so ? so.card || (so.token && so.token.name) || null : t.cardId || null;
            }),
          };
          return;
        }
        Flow.placeQueuedTrigger(state, q.indexOf(mine[0]));
        return;
      }
      state.triggerQueue = [];
    },

    placeQueuedTrigger(state, qIdx) {
      const t = state.triggerQueue[qIdx];
      if (!t) return;
      state.triggerQueue.splice(qIdx, 1);
      const def = {
        kind: "trigger",
        controller: t.controller,
        label: t.label,
        program: t.program,
        source: t.source,
        cardId: t.cardId || null,
        ctx: t.ctx || {},
        optional: !!t.optional,
        exhaustSelf: !!t.exhaustSelf,
        targetSpecs: t.targetSpecs || [],
        carry: t.carry || null,
        openerKind: "trigger",
      };
      if (t.vars) def.vars = Object.assign({}, t.vars);
      Flow.addChainItem(state, def);
    },

    addChainItem(state, def) {
      const item = Object.assign(
        {
          id: state.nextChainId++,
          status: "pending",
          targets: def.carry ? Object.assign({}, def.carry) : {},
          modes: null,
          pc: 0,
          vars: {},
        },
        def
      );

      if (!item.cardId) {
        const ref = item.iid || item.source;
        const refCard = ref ? Core.card(state, ref) : null;
        if (refCard) item.cardId = refCard.id;
      }
      const opensChain = state.chain.length === 0;
      state.chain.push(item);
      const below = state.chain.length > 1 ? state.chain[state.chain.length - 2] : null;
      RB.FX.emit(state, RB.FX.chainEvent("chained", item, {
        link: state.chain.length, respondsTo: below ? below.label : null, fromZone: item.fromZone || null,
      }));
      state.passCount = 0;
      state.needCleanup = true;
      if (opensChain) state.chainOpener = item.openerKind || "play";
      return item;
    },

    stepFrame(state, frame) {
      if (frame.k === "mulligan") {
        if (frame.i >= frame.order.length) {
          state.turn.num = 1;
          Flow.startTurn(state, state.turn.player, true);
          return "done";
        }
        const p = frame.order[frame.i];
        state.pending = {
          kind: "mulligan", player: p,
          note: "Select up to 2 cards to mulligan (they are recycled after redraw)",
        };
        return "wait";
      }
      if (frame.k === "finalize") return RB.Play.stepFinalize(state, frame);
      if (frame.k === "resolve") return RB.FX.stepResolve(state, frame);
      if (frame.k === "deathChoice") return Flow.stepDeathChoice(state, frame);
      if (frame.k === "moveCost") return Flow.stepMoveCost(state, frame);
      if (frame.k === "moveGroup") return Flow.stepMoveGroup(state, frame);
      throw new Error("unknown frame " + frame.k);
    },

    stepDeathChoice(state, frame) {
      const f = frame.rule
        ? Object.assign({}, frame.rule, { source: frame.ruleSrc, label: frame.rule.label || Core.name(state, frame.ruleSrc) })
        : state.fx.find(function (x) { return x.id === frame.fxId; });
      const o = state.objs[frame.iid];
      const finishDeath = function () {
        if (o && o.zone === "board") Flow.killObjs(state, [frame.iid], Object.assign({ skipReplace: true }, frame.attribution || {}));
        return "done";
      };
      if (!f || !o || o.zone !== "board") return finishDeath();
      const p = f.payer === "controller" ? o.controller
        : f.controller !== undefined ? f.controller : o.controller;
      const a = frame.answers;
      if (f.mandatory) a.take = true;
      if (a.take === undefined) {
        const bits = [];
        if (f.cost) {
          if (f.cost.energy) bits.push(f.cost.energy + " energy");
          if (f.cost.anyPower) bits.push(f.cost.anyPower + " any power");
          if (f.cost.pips) bits.push(f.cost.pips + " " + ((f.cost.domains || [])[0] || "") + " power");
        }
        if (f.exhaustsSource) bits.push("exhaust " + Core.name(state, f.source));
        if (f.killsSource) bits.push("kill " + Core.name(state, f.source));
        if (f.spendBuff) bits.push("spend its buff");
        state.pending = {
          kind: "choose", player: p, tag: "may",
          prompt: (f.label || "Replace this death") + ": " + Core.name(state, frame.iid) +
            " would die - " + (bits.length ? "pay " + bits.join(" + ") + " to " : "") + "recall it exhausted instead?",
          options: ["Yes", "No"], frameKey: "take",
        };
        return "wait";
      }
      if (a.take === false) {
        if (!frame.rule) (f.declined = f.declined || []).push(frame.iid);
        return finishDeath();
      }
      if (f.cost && !a.paid) {
        const cost = RB.Play.costFromRes(f.cost, null);
        if (!RB.Play.poolPotentialCovers(state, p, cost, {})) {
          Core.log(state, (f.label || "replacement") + ": cannot pay, the death proceeds.",
            { k: "death", p: p, iids: [frame.iid] });
          if (!frame.rule) (f.declined = f.declined || []).push(frame.iid);
          return finishDeath();
        }
        state.pending = { kind: "pay", player: p, cost: cost, note: f.label || "Death replacement", cancellable: false };
        return "wait";
      }
      if (f.exhaustsSource && state.objs[f.source]) state.objs[f.source].ready = false;
      if (f.killsSource) Flow.killObjs(state, [f.source], { via: "deathReplace", skipReplace: true });
      if (f.spendBuff) Flow.spendBuff(state, frame.iid, p);
      Flow.recallExhausted(state, frame.iid, { log: Core.name(state, frame.iid) + " is recalled exhausted instead of dying (" + (f.label || "replacement") + ")." });
      if (f.once) f.done = true;
      state.fx = state.fx.filter(function (x) { return !x.done; });
      return "done";
    },

    performStandardMove(state, p, units, dest) {
      const extra = RB.Play.moveSurcharge(state, p, units, dest);
      if (extra > 0) {
        state.tasks.push({
          k: "moveCost", player: p, units: units.slice(), dest: dest,
          cost: { energy: 0, pips: [], anyPower: extra }, answers: {},
        });
        return;
      }
      Flow.moveStandard(state, p, units, dest);
    },

    moveStandard(state, p, units, dest) {
      for (const iid of units) state.objs[iid].ready = false;
      Flow.moveUnits(state, units, dest, { by: p, standard: true });
      Core.log(state, state.players[p].name + " moves " + units.map(function (u) { return Core.name(state, u); }).join(", ") +
        " to " + Core.locName(state, dest) + ".",
        { k: "move", p: p, iids: units.concat(dest.t === "bf" ? [dest.iid] : []) });
    },

    moveGroupUnits(state, p) {
      return Core.boardObjs(state, function (o, iid) {
        return o.controller === p && Core.isType(state, iid, "unit");
      });
    },

    moveGroupCands(state, p, dest, picked) {
      const out = [];
      for (const iid of Flow.moveGroupUnits(state, p)) {
        if (picked.indexOf(iid) >= 0) continue;
        if (RB.Play.moveBlocked(state, p, picked.concat([iid]), dest)) continue;
        out.push(iid);
      }
      return out;
    },

    moveGroupOrder(state, p, picked) {
      return Flow.moveGroupUnits(state, p).filter(function (iid) { return picked.indexOf(iid) >= 0; });
    },

    stepMoveGroup(state, frame) {
      const p = frame.player;
      const picked = frame.picked || [];
      if (frame.go) {
        Flow.performStandardMove(state, p, picked, frame.dest);
        return "done";
      }
      const cands = Flow.moveGroupCands(state, p, frame.dest, picked);
      if (!cands.length && !picked.length) return "done";
      state.pending = {
        kind: "moveGroup", player: p, dest: frame.dest,
        picked: picked.slice(), cands: cands,
        canGo: picked.length >= 2 || (picked.length === 1 && !cands.length),
      };
      return "wait";
    },

    stepMoveCost(state, frame) {
      const p = frame.player;
      if (!frame.answers.paid) {
        if (!RB.Play.poolPotentialCovers(state, p, frame.cost, {})) {
          Core.log(state, state.players[p].name + " cannot pay the extra cost - the move does not happen.",
            { k: "move", p: p, iids: frame.units });
          return "done";
        }
        state.pending = {
          kind: "pay", player: p, cost: frame.cost,
          note: "Extra cost to move " + frame.units.length + " units to " + Core.name(state, frame.dest.iid),
          cancellable: false,
        };
        return "wait";
      }
      const units = frame.units.filter(function (iid) {
        const o = state.objs[iid];
        return o && o.zone === "board" && o.controller === p && o.ready;
      });
      Flow.moveStandard(state, p, units, frame.dest);
      return "done";
    },

    startTurn(state, p, first) {
      state.turn.player = p;
      state.turn.phase = "awaken";
      state.turn.step = 0;
      state.turnFacts = RB.Setup.freshTurnFacts();
      state.players[p].turnsTaken = (state.players[p].turnsTaken || 0) + 1;
      state.turn.conqueredBfs = {};
      state.turn.damaged = {};
      state.turn.heldBfs = {};
      delete state.turn.namedDamage;
      for (const bfIid of state.battlefields) state.objs[bfIid].scoredBy = [];
      for (const iid of Core.boardObjs(state)) {
        state.objs[iid].flags.desigA = false;
        state.objs[iid].flags.desigD = false;
        state.objs[iid].flags.movedThisTurn = 0;
      }
      Core.log(state, "Turn " + state.turn.num + " — " + state.players[p].name + ".", { k: "turn", p: p });
    },

    stepPhase(state) {
      const t = state.turn;
      const p = t.player;

      if (t.phase === "awaken") {
        const woke = [];
        for (const iid of Core.boardObjs(state)) {
          const o = state.objs[iid];
          if (o.controller === p && !o.ready && !Core.readyBlocked(state, iid)) { o.ready = true; woke.push(iid); }
        }
        const legend = state.objs[state.players[p].legendIid];
        legend.ready = true;
        for (const iid of woke) RB.FX.emit(state, { type: "ready", iid: iid, player: p });
        t.phase = "beginning";
        t.step = 0;
        return true;
      }

      if (t.phase === "beginning") {
        if (t.step === 0) {
          t.step = 1;
          for (const iid of Core.boardObjs(state)) {
            const o = state.objs[iid];
            if (o.controller === p && Core.hasKw(state, iid, "temporary") && !Flow.temporarySuppressed(state, iid)) {
              state.triggerQueue.push({
                controller: p,
                source: iid,
                label: "Temporary: kill " + Core.name(state, iid),
                program: [{ op: "kill", to: "source", credit: false }],
              });
            }
          }
          RB.FX.emit(state, { type: "beginningPhase", player: p });
          return true;
        }
        if (t.step === 1) {
          if (!t.holdQueue) {
            t.holdQueue = state.battlefields.filter(function (bfIid) {
              return state.objs[bfIid].controller === p;
            });
          }
          if (t.holdQueue.length) {
            const bfIid = t.holdQueue.shift();
            const bf = state.objs[bfIid];
            if (bf.controller === p && bf.scoredBy.indexOf(p) < 0) Flow.score(state, p, bfIid, "hold");
            return true;
          }
          t.holdQueue = null;
          t.phase = "channel";
          return true;
        }
      }

      if (t.phase === "channel") {
        let n = 2;
        if (t.num <= 2 && p !== state.firstPlayer && !state.players[p].extraChanneled) {
          n = 3;
          state.players[p].extraChanneled = true;
        }
        const capped = RB.Scripts.anySource(state, "capChannelPhase", { atBf: true });
        if (capped) n = Math.min(n, 1);
        Flow.channel(state, p, n);
        t.phase = "draw";
        return true;
      }

      if (t.phase === "draw") {
        const skip = RB.Scripts.anySource(state, "skipDrawPhase", { controller: p });
        if (skip) Core.log(state, state.players[p].name + " skips their Draw Phase.", { k: "phase", p: p });
        else Flow.draw(state, p, 1);
        t.phase = "mainStart";
        return true;
      }

      if (t.phase === "mainStart") {
        Core.emptyAllPools(state);
        t.phase = "main";
        RB.FX.emit(state, { type: "mainPhase", player: p });
        return true;
      }

      if (t.phase === "main") {
        state.priority = p;
        state.pending = { kind: "act", player: p };
        return true;
      }

      if (t.phase === "ending") {
        if (t.step === 0) {
          t.step = 1;
          RB.FX.emit(state, { type: "endOfTurn", player: p });
          return true;
        }
        if (t.step === 1) {
          for (const iid of Core.boardObjs(state)) {
            const o = state.objs[iid];
            if (Core.isType(state, iid, "unit") && o.damage.length) o.damage = [];
            if (o.stunned) o.stunned = false;
          }
          Flow.expireGrants(state, "turn");
          Core.emptyAllPools(state);
          t.step = 2;
          return true;
        }
        if (t.step === 2) {
          const extras = state.extraTurns;
          const next = extras[p] > 0 ? p : Core.otherPlayer(p);
          if (extras[p] > 0) {
            extras[p] -= 1;
            Core.log(state, state.players[p].name + " takes an extra turn.", { k: "turn", p: p });
          }
          state.turn.num += 1;
          Flow.startTurn(state, next);
          return true;
        }
      }

      throw new Error("phase stuck: " + t.phase);
    },

    expireGrants(state, dur) {
      for (const iid in state.objs) {
        const o = state.objs[iid];
        if (o.grants.length) {
          o.grants = o.grants.filter(function (g) { return g.dur !== dur; });
        }
      }
      state.fx = state.fx.filter(function (f) { return f.dur !== dur; });
    },
  };

  window.RB.Flow = Flow;
})();
